/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Ref_N6Inputs */

const en_viewer_ref_n6 = /** @type {(inputs: Viewer_Ref_N6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Object keys are joined with dots, rooted at root.`)
};

const ko_viewer_ref_n6 = /** @type {(inputs: Viewer_Ref_N6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`객체 키는 root에서 시작해 점으로 이어집니다.`)
};

const ja_viewer_ref_n6 = /** @type {(inputs: Viewer_Ref_N6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オブジェクトキーは root から始まりドットでつながれます。`)
};

/**
* | output |
* | --- |
* | "Object keys are joined with dots, rooted at root." |
*
* @param {Viewer_Ref_N6Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_ref_n6 = /** @type {((inputs?: Viewer_Ref_N6Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Ref_N6Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_ref_n6(inputs)
	if (locale === "ko") return ko_viewer_ref_n6(inputs)
	return ja_viewer_ref_n6(inputs)
});